import { Component, Directive, HostBinding, Input } from "@angular/core";
import { Constructor } from "@angular/material/core/common-behaviors/constructor";

export type Width =
  // fixed widths
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | "0"
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  // percentage widths
  | "05"
  | "10"
  | "15"
  | "20"
  | "25"
  | "30"
  | "35"
  | "40"
  | "45"
  | "50"
  | "55"
  | "60"
  | "65"
  | "70"
  | "75"
  | "80"
  | "85"
  | "90"
  | "95"
  | "100"
  | "33"
  | "66"
  | "one-third"
  | "two-thirds";

// todo: figure out return type for mixins
// tslint:disable-next-line:typedef
export function WithWidth<Base extends Constructor<Component>>(
  BaseClass: Base
) {
  @Directive()
  // tslint:disable-next-line:class-name
  class _WithWidth extends BaseClass {
    @Input()
    width?: Width;

    protected get widthClassList(): string[] {
      return widthToClassList(this.width);
    }
  }

  return _WithWidth;
}

@Component({
  selector: "exp-width-container, [exp-width-container]",
  template: `<ng-content></ng-content>`
})
export class WidthContainerComponent extends WithWidth(class {}) {
  @HostBinding("class")
  get hostClass(): string {
    return this.widthClassList
      .filter((className) => className != null)
      .join(" ");
  }
}

function widthToClassList(width?: Width): string[] {
  if (width === undefined) {
    return [];
  }
  if (!isValidWidth(width)) {
    // tslint:disable-next-line:no-console
    console.warn(`Unsupported Width: ${width}`);
    return [];
  }

  return width == null ? [] : [`w--${width}`];
}

function isValidWidth(width?: any): width is Width {
  if (width === "one-third" || width === "two-thirds" || width === "05") {
    return true;
  }

  if (isNaN(Number(width))) {
    return false;
  }

  const widthNum = Number(width);

  if (!Number.isInteger(widthNum)) {
    return false;
  }

  // fixed widths
  if (widthNum >= 0 && widthNum <= 8) {
    return true;
  }

  // percentage widths
  if (
    widthNum < 0 ||
    widthNum > 100 ||
    (widthNum % 5 !== 0 && widthNum % 33 !== 0)
  ) {
    return false;
  }

  return true;
}
